export const config = {
  apiUrl: process.env.REACT_APP_API_URL as string,
  graphQLUrl: process.env.REACT_APP_GRAPHQL_URL as string,
  environment: process.env.NODE_ENV,
  sentryDSN: process.env.REACT_APP_SNTRY_DSN,
  isPipeline: process.env.REACT_APP_IS_PIPELINE,
};
